import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../common/components/formControls';
import validators from '../common/services/validators';
import { withTranslation } from 'react-i18next';

const passwordMinLength = validators.minLength(6);

const ResetPasswordForm = ({ error, handleSubmit, pristine, submitting, t }) => {

	return (
		<form onSubmit={handleSubmit} className='form-login'>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='password' component={Input} type='password' placeholder={t('FO_ResetPassword_Password')} icon='fa fa-lock' validate={[validators.required, passwordMinLength]} />
			<Field name='confirmPassword' component={Input} type='password' placeholder={t('FO_ResetPassword_ConfirmPassword')} icon='fa fa-lock' validate={[validators.required, passwordMinLength]} />
			<Field name='token' component={Input} type='hidden' />
			<div className='form-actions'>
				<Button type='submit' disabled={pristine || submitting} className='btn btn-primary btn-auth'>
					{t('FO_ResetPassword_Submit')} <i className='fa fa-arrow-circle-right' />
				</Button>
			</div>
		</form>
	);
};

ResetPasswordForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'resetPassword' })(withTranslation()(ResetPasswordForm));